import React, { useEffect, useState } from "react";
import { Button, Dropdown, Space } from "antd";
import { Saas22Logo, SignInIcon, downHeaderArrow } from "../../assets/img";
import "./Topbar.css";
import { useAuth } from "../../context";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../../confiq/confiq";
import { useUserRole } from "../../context/userContext";
import SignInPopup from "../Modal/signIn";
import { Menu } from "heroicons-react";
import MobileMenu from "../Sidebar/mobileMenu";

function Topbar({isSignedIn}) {
  const [showSignInPopup, setShowSignInPopup] = useState(false);
  const { login, logout } = useAuth();
  const userRole = useUserRole();
  const [userProfile, setuseProfile] = useState();
  const [headerData, setheaderData] = useState(null);
  const navigate = useNavigate();
  const { userToken } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (userToken) {
      axios
        .get(`${config.apiUrl}api/user/info`, {
          headers: config.headers,
        })
        .then((response) => {
          setuseProfile(response?.data?.data);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
    axios
      .get(`${config.apiUrl}api/home/header`, {
        headers: config.headers,
      })
      .then((response) => {
        setheaderData(response?.data?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [userToken]);

  const handleLogout = () => {
    const logoutRedirect = {
      Admin: "/admin/signin",
      Partner: "/signin",
    };

    const redirectPath = logoutRedirect[userRole] || "/signin";
    const state = userRole ? {} : { signinHide: true };
    navigate(redirectPath, { state });
    localStorage.clear();
    window.location.reload();
    setTimeout(() => {
      login(null);
    }, 1000);
  };

  const handleLogoOnclick = () => {
    if (userToken) {
      navigate("/home");
    } else {
      navigate("/");
    }
  };

  return (
    <div className="topbar-wrapper">
      <div className="topbar-left">
        <Space
          size={[24, 16]}
          className="header-gap"
          wrap
          style={{ cursor: "pointer" }}
        >
          <img
            src={headerData?.logo?.data?.attributes?.url}
            alt={headerData?.logo?.data?.attributes?.alternativeText}
            className="logo"
            onClick={handleLogoOnclick}
          />
        </Space>
      </div>

      <div className="topbar-right">
        <div className="header-links">
          {headerData?.menu.map((item) => (
            <a
              key={item?.id}
              href={item?.mainList?.url}
              target={item?.mainList?.target || "_self"}
              className="header-link"
            >
              {item?.mainList?.text}
            </a>
          ))}
        </div>

        {userProfile ? (
          <Dropdown
            menu={{
              items: [
                {
                  key: "1",
                  label: (
                    <div
                      onClick={() => {
                        handleLogout();
                        logout();
                      }}
                    >
                      Logout
                    </div>
                  ),
                },
              ],
            }}
          >
            <Space size={[8, 4]} className="cursor-pointer">
              <img src={downHeaderArrow} alt="Arrow" className="header-arrow" />
            </Space>
          </Dropdown>
        ) : (
          headerData?.callToAction.map((item) => (
            <Button
              key={item?.id}
              className="font-semibold cursor-pointer"
              onClick={() => {
                if (!userRole || !userToken) {
                  setShowSignInPopup(true);
                } else {
                  handleLogout();
                  logout();
                }
              }}
              style={{ width: "100px", minWidth: "100px", height: "36px" }}
              // type="primary"
            >
              {item?.title}
            </Button>
          ))
        )}

        <SignInPopup
          visible={showSignInPopup}
          onClose={() => setShowSignInPopup(false)}
        />
      </div>
      <div className="block md:hidden">
        {open ? (
          <div onClick={() => setOpen(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18 18 6M6 6l12 12"
              />
            </svg>
          </div>
        ) : (
          <Menu onClick={() => setOpen(true)} />
        )}
      </div>
      <MobileMenu setOpen={setOpen} open={open} isSignedIn={isSignedIn}/>
    </div>
  );
}

export default Topbar;
